import React, { useState, useEffect, Fragment, useMemo, useRef } from 'react'
import { useHistory } from 'react-router';
import { processNumAndComma, TrackingSignImageURL, valdiatePage } from '../../global';
import { BulkTrackingAPI } from '../../services/reportservice';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';
import { ButtonPrimarySm } from '../../components/formelements';


export const btColumns = [
  { header: "Consignment Number", key: "ConsignmentNumber" },
  { header: "Order ID", key: "ORDERID" },
  { header: "COD Amount", key: "CODAmount" },
  { header: "Handover Date", key: "AccountRcvDate" },
  { header: "Origin", key: "OriginBranch" },
  { header: "Destination", key: "DestBranch" },
  { header: "Consignee Name", key: "ConsigneeName" },
  { header: "Consignee Number", key: "ConsigneeNo" },
  { label: "Weight", key: "Weight" },
  { label: "Pieces", key: "Pieces" },
  { header: "Current Status", key: "CurrentStatus" },
  { header: "Status Time", key: "TransactionTime" },
  { header: "Reason", key: "POD_Reason" },
  { header: "Number of Attempts", key: "ActualAttempts" },
  { header: "Hold for Advice", key: "HoldForAdvice" },
  { header: "Failed Delivery Reason", key: "Failed_Delivery_Reason" },
  { header: "Shipment TAT Compliance", key: "ShipmentTAT" },
  { header: "Payment Status", key: "PaymentSTATUS" },
  { header: "Received By", key: "receivedBy" },
  { header: "Proof of Delivery", key: "POD" },
  { header: "Account #", key: "AccountNo" },
  { header: "Account Title", key: "AccountName" },
  { header: "Pickup Location", key: "PickupLocation" },
];


const BulkTracking = ({setIsDefault, myWorker}) => {

    const dispatch = useDispatch();
    const { accounts, userInfo } = useSelector(state => state.appData);
    const [cnTotalEntries, setCnTotalEntries] = useState(0);
    const [cnIdsValidEntry, setCnIdsValidEntry] = useState(true);
    const [cn, setcn] = useState('');
    const [imageURLOne, setImageURLOne] = useState([])
    const [data, setData] = useState([]);
    const [grid, setGrid] = useState([]);
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);



    const [gridWithPOD, setGridWithPOD] = useState([]); // updated grid with POD field
    
    const searchObjInit = {
        consignmentNumber: '',
        BookingDate: '',
        orderRefNo: '',
        weight: '',
        totalAmount: '',
        OrgBranch: '',
        consignee: '',
        consigneePhoneNo: '',
        service: '',
        CODAmount: '',
        destbranch: '',

    };

    const history = useHistory();



    const isImageAvailable = async (urlParam, cn) => {
        return new Promise((resolve) => {
            const url = `${urlParam}/${cn}.jpg`;
            const image = new Image();

            image.onload = function () {
                if (this.width > 0) {
                    resolve({ cn, pod: url });
                } else {
                    resolve({ cn, pod: '' });
                }
            };

            image.onerror = function () {
                resolve({ cn, pod: '' });
            };

            image.src = url;
        });
    };

    useEffect(() => {
        const fetchAllPODs = async () => {
            const updatedGrid = [...originalGrid]; // clone original data
            const podChecks = await Promise.all(
                updatedGrid.map(async (item) => {
                    if (item.CurrentStatus === "Delivered") {
                        const result = await isImageAvailable(TrackingSignImageURL, item.ConsignmentNumber);
                         setImageURLOne(prev => [...prev, {cn: result.cn, url: result.pod, showImage: result?.pod.length > 0 ?  true : false}])
                        return { ...item, POD: result.pod };
                    } else {
                        return { ...item, POD: '' };
                    }
                })
            );
            setGridWithPOD(podChecks);
        };

        fetchAllPODs();
    }, [originalGrid]);

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });

    const gridKeys = [
        {key: '', name: 'Action', searchBox: false, visible: true},
        {key: 'ConsignmentNumber', name: 'Consignment No', searchBox: true, visible: true},
        {key: 'ORDERID', name: 'Order ID', searchBox: true, visible: true},
        {key: 'CODAmount', name: 'COD Amount', searchBox: true, visible: true},
        {key: 'AccountRcvDate', name: 'Handover Date', searchBox: true, visible: true},
        {key: 'OriginBranch', name: 'Origin', searchBox: true, visible: true},
        {key: 'DestBranch', name: 'Destination', searchBox: true, visible: true},
        {key: 'ConsigneeName', name: 'Consignee Name', searchBox: true, visible: true},
        {key: 'ConsigneeNo', name: 'Consignee Number', searchBox: true, visible: true},
        {key: 'Weight', name: 'Weight', searchBox: true, visible: true},
        {key: 'Pieces', name: 'Pieces', searchBox: true, visible: true},
        {key: 'CurrentStatus', name: 'Current Status', searchBox: true, visible: true},
        {key: 'TransactionTime', name: 'Status Time', searchBox: true, visible: true},
        {key: 'POD_Reason', name: 'Reason', searchBox: true, visible: true},
        {key: 'ActualAttempts', name: 'Number of Attempts', searchBox: true, visible: true},
        {key: 'HoldForAdvice', name: 'Hold for Advice', searchBox: true, visible: true},
        {key: 'Failed_Delivery_Reason', name: 'Failed Delivery Reason', searchBox: true, visible: true},
        {key: 'ShipmentTAT', name: 'Shipment TAT Compliance', searchBox: true, visible: true},
        {key: 'PaymentSTATUS', name: 'Payment Status', searchBox: true, visible: true},
        {key: 'receivedBy', name: 'Received By', searchBox: true, visible: true},
        {key: 'CODAmount', name: 'Proof of Delivery', searchBox: true, visible: true},
        {key: 'AccountNo', name: 'Account #', searchBox: true, visible: true},
        {key: 'AccountName', name: 'Account Title', searchBox: true, visible: true},
        {key: 'PickupLocation', name: 'Pickup Location', searchBox: true, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });


    // useEffect(() => {
    //     if (true) {
    //         history.push('/login');
    //     }
    // }, []);


    const onSearch = async () => {  
        fileRef.current.value = null;

        setData([])
        if (!cn) {
            alert('Enter Consignment No or Upload Consignments');
            setGrid([]);
            setOriginalGrid([]);
            setGridWithPOD([]);
            return;
        }
        const consignmentsIds = cn.split(',')

        const d ={
            Accounts:accounts,
            Consignments:consignmentsIds
        }

        dispatch(setLoading({ data: true }));

        var rs = await BulkTrackingAPI(d);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                setGrid(rs.data);
                setOriginalGrid(rs.data);
            } else {
                alert('No Data Found');
                setGrid([]);
                setOriginalGrid([]);
                setGridWithPOD([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
            setOriginalGrid([]);
            setGridWithPOD([]);
        }
    }

    const onChange = (e) => {
        const cnLengthValidated = validateCnIdsLength(e.target.value);
        setCnTotalEntries(cnLengthValidated)
        setcn(e.target.value)
        if (cnLengthValidated > 100)
            setCnIdsValidEntry(false)
        else
            setCnIdsValidEntry(true)
    }

    const validateCnIdsLength = (value) => (value.split(',').filter(e => e.length > 0).length)

    const fileRef = useRef(null);
    
    useEffect(() => {
        myWorker.onmessage = function (event) {
            const { sts, msg, dt } = event.data;
            if (sts === 0) {
                if (dt.length > 100) {
                    alert('Maximum Tracking length is 100.');
                    return false;
                }
                const consignmentNumbers = dt.map(item => item.ConsignmentNumber).join(',');
                setcn(consignmentNumbers);

            } else {
                alert(msg);
            }
            dispatch(setLoading({ data: false }));
        }
    }, [])

    console.log(gridWithPOD);

    const onUpload = async () => {
        dispatch(setLoading({ data: false }));
        const file = fileRef.current.files[0];
        myWorker.postMessage({ file: file});
    }

    return userInfo &&
        <section className="section">
            <div className="card" style={{ padding: 10 }}>

                <div className="row mt-2">
                    <label className={!cnIdsValidEntry && 'text-danger'}>
                        Total consignment count: {cnTotalEntries}
                    </label>
                    {!cnIdsValidEntry && <div className='text-danger'>
                        Maximum consignment tracking length is 100.
                    </div>}
                </div>


                <div className="row pb-2">
                    <div className="col-lg-6 col-sm-12">
                        <label>Consignment No</label>
                        <input type="text" placeholder='Example. CN1,CN2,CN3'onInput={processNumAndComma} className="form-control" value={cn} onChange={onChange} />
                    </div>
                    <div className="col-lg-4 col-sm-12">
                        <label>File</label>
                        <input
                            type='file'
                            ref={fileRef}
                            className='form-control'
                            onChange={(e) => {

                                dispatch(setLoading({ data: false }));
                                const file = fileRef.current.files[0];
                                myWorker.postMessage({ file: file});
                            }}
                            style={{
                                height: '37px',
                                padding: '7.5px 13px'
                            }}
                        />
                    </div>

                    <div className="col-lg-2 col-sm-12" style={{ textAlign: "right" }}>
                    
                        <a href="Sample5.csv" download className="btn btn-primary badge-orange" style={{
                            marginTop: '1.5rem', height: '37px'}}>CSV Sample</a>
                               
                    </div>

                    
                </div>

                <div className="row pb-2">
                    <div className="col-lg-12 col-sm-12" style={{ textAlign: 'center'}}>
                        <button type="button" disabled={!cnIdsValidEntry} className="btn btn-primary" style={{ marginTop: '1.3rem', width: '300px' }} onClick={onSearch}>Track</button>
                    </div>
                </div>

                {
                originalGrid && originalGrid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <div className='row'>
                            <div className="col-lg col-lg-12" style={{ textAlign: 'right' }}>
                                {/* <ExportExcelQSR data={gridWithPOD} /> */}
                           <ExportExcelButton data={gridWithPOD} columns={btColumns} fileName="BulkTrackingReport" label='Download'
                                />
                            </div>
                        </div>
                        
                        <br />
                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr key={index}>
                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                            <td>
                                                <div style={{ width: '92px' }}>
                                                    <ButtonPrimarySm text={(!x.TicketStatus || x.TicketStatus === 0) ? 'Launch Ticket' : 'View Ticket'} onClick={e => {
                                                       
                                                        sessionStorage.setItem('complaintData', JSON.stringify({
                                                            cn: x.ConsignmentNumber,
                                                            codAmount: x.CODAmount,
                                                            screen: 'tracking_2'
                                                        }));
                                                        window.open('/cplight/complaint', '_blank');
                                                    }} />
                                                </div>
                                            </td>
                                            <td><span style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={(e) => {

                                                e.preventDefault();
                                                sessionStorage.setItem('cn', x.ConsignmentNumber);
                                                window.open('/cplight/tracking_2', '_blank');

                                            }}>{x.ConsignmentNumber}</span></td>
                                            <td>{x.ORDERID}</td>
                                            <td>{x.CODAmount}</td>
                                            <td>{x.AccountRcvDate}</td>
                                            <td>{x.OriginBranch}</td>
                                            <td>{x.DestBranch}</td>
                                            <td>{x.ConsigneeName}</td>
                                            <td>{x.ConsigneeNo}</td> 
                                            <td>{x.Weight? x.Weight+" KG" : ""}</td> 
                                            <td>{x.Pieces}</td> 
                                            <td>{x.CurrentStatus}</td>
                                            <td>{x.TransactionTime}</td>
                                            <td>{x.POD_Reason}</td>
                                            <td>{x.ActualAttempts}</td>
                                            <td>
                                                {
                                                    x.HoldForAdvice == "YES" ? 
                                                    <span style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={(e) => {
                                                        e.preventDefault();
                                                        window.open('/cplight/shipperadvice', '_blank');
                                                    }}>{x.HoldForAdvice}</span> : 
                                                    <span>{x.HoldForAdvice}</span>
                                                }
                                                
                                            </td>
                                            <td>{x.Failed_Delivery_Reason}</td>
                                            <td>{x.ShipmentTAT}</td>
                                            <td>{x.PaymentSTATUS}</td>
                                            <td>{x.receivedBy}</td>
                                            <td>{imageURLOne.filter(e => e.cn == x.ConsignmentNumber).length > 0 &&  <>
                                                <div ><a href={imageURLOne.filter(e => e.cn == x.ConsignmentNumber)[0]?.url} className="btn btn-sm btn-primary " type="image/JPEG" target="_blank">View Signature</a></div></>}</td>
                                            <td>{x.AccountNo}</td>
                                            <td>{x.AccountName}</td>
                                            <td>{x.PickupLocation}</td>
                                        </tr>
                                    </Fragment>
                                )
                            }
                        />
                    </div>
                </div>
            }
            </div>
        </section>
}

export default BulkTracking;